import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Login",
      component: () => import("../components/Login.vue"),
      meta: {
        title:
          "Let's Practice AWS Solutions Architect - Associate（AWSソリューションアソシエイト問題集）",
        desc: "勉強しよう！AWS ソリューションアーキテクト – アソシエイト 資格",
      },
      // beforeEnter() {
      //   window.location = "http://www.google.com"
      // }
    },
    {
      path: "/home",
      name: "Home",
      component: () => import("../components/Home.vue"),
      meta: {
        title:
          "Let's Solve AWS Solutions Architect - Associate（AWSソリューションアソシエイト問題集）",
        desc:
          "本格的にといてみよう！AWS ソリューションアーキテクト – アソシエイト 資格",
      },
      beforeEnter(to, from, next) {
        let cookievalue = Vue.cookie.get("awsexhome");
        if (cookievalue) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "*",
      name: "NotFound",
      beforeEnter() {
        window.location = "/";
      },
    },
  ],
});
